<template>
  <el-dialog class="store-dialog" width="900px" title="选择商品" :visible.sync="showDialog" :close-on-click-modal="false" :before-close="cancelAction" append-to-body>
    <div v-if="params.item_type === 'normal'" style="margin-bottom: 15px;">
      <el-row :gutter="10">
        <el-col :span="4">
          <div style="margin-top: 10px">
            <el-checkbox v-model="params.choose_all" label="选中全部" border @change="chooseAll"></el-checkbox>
          </div>
        </el-col >
        <el-col :span="6">
          <el-input placeholder="输入商品名称" v-model="params.keywords" clearable class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="searchByKey"></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="输入商品货号" v-model="params.sku_bn" clearable class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="searchByKey"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <el-table ref="multipleTable" v-if="singleData" :data="itemsData" tooltip-effect="dark" style="width: 100%" v-loading="loading">
    </el-table>
    <el-table ref="multipleTable" v-else :data="itemsData" tooltip-effect="dark" style="width: 100%" @select="handleSelectChange" @select-all="handleSelectAll" v-loading="loading" :row-key="getRowKeys" :select-on-indeterminate="false">
      <el-table-column type="selection" :selectable="disabledItem" :reserve-selection="true" width="50"></el-table-column>
      <el-table-column prop="sku_id" label="商品ID" width="100"></el-table-column>
      <el-table-column prop="sku_bn" label="货号" width="100">
        <template slot-scope="scope">
          {{scope.row.sku_bn}}
        </template>
      </el-table-column>
      <el-table-column prop="sku_name" label="商品名称"></el-table-column>
      <el-table-column prop="price" label="价格" width="100" :formatter="priceformatter"></el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="pager">
      <el-pagination
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="total_count" :page-size="params.pageSize">
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelAction">取 消</el-button>
      <el-button type="primary" @click="saveStoreAction">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  // import { getItemsList, getCategory, getTagList } from '@/api/goods'
  import { getSkuList } from '@/api/sharer'
  import { getShippingTemplatesList } from '@/api/shipping'
  import { getDefaultCurrency } from '@/api/company'

  export default {
    props: {
      itemsVisible: {
        type: Boolean,
        default: false
      },
      getStatus: {
        type: Boolean,
        default: false
      },
      relStore: {
        type: Object,
        default: function () {
          return {}
        }
      },
      relItemsIds: {
        type: Array,
        default: []
      },
      hiddenData: {
        type: Array,
        default: function () {
          return []
        }
      },
      itemType: {
        type: String,
        default: ''
      },
      filter: [String, Object],
      notSku: {
        type: Boolean,
        default: false
      },
      isSpec: {
        type: Boolean,
        default: false
      },
      limitNum: {
        type: Number,
        default: 0
      },
      single: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        itemsData: [],
        multipleSelection: [],
        selectRows: [],
        total_count: '',
        // activeType: 'first',
        // tag: {
        //   dialog: false,
        //   editItem: [],
        //   list: [],
        //   form: {
        //     tag_ids: [],
        //     item_ids: []
        //   },
        //   currentTags: [],
        //   tags: []
        // },
        select_tags_value: [],
        params: {
          page: 1,
          pageSize: 20,
          keywords: '',
          sku_bn: '',
          item_type: 'normal',
          // special_type: 'normal',
          templates_id: '',
          is_sku: false,
          tag_id: '',
          choose_all: false
        },
        hiddenItem: [],
        // templatesList: [],
        currency: {},
        cursymbol: '￥',
        // templateRadio: ''
      }
    },
    methods: {
      chooseAll (val) {
        if (val == true) {
          this.$message({message: '请稍后...', type: 'warning'})
          this.params.page = 1
          this.params.pageSize = 2000
          getSkuList(this.params).then(response => {
            this.$message({message: '本次选中了' + this.total_count + '个商品', type: 'success'})
            var data = response.data.data.list
            this.selectRows = []
            this.selectRows = data
            //选中
            this.$refs.multipleTable.clearSelection()
            this.itemsData.forEach(item => {
              let checked = this.selectRows.find(n => n.sku_id === item.sku_id)
              if (checked) {
                this.$refs.multipleTable.toggleRowSelection(item)
              }
            })
          })
        } else {
          this.selectRows = []
          this.$refs.multipleTable.clearSelection()
          this.$message({message: '本次清空了所有选中商品', type: 'success'})
          this.selectRows = []
        }
      },
      handleTabClick () {
        this.getNewsList()
      },
      getTemplateRow (index, row) {
        this.selectRows = new Array(row)
      },
      disabledItem (row, index) {
        if (this.hiddenItem.indexOf(row.sku_id) > -1) {
          return false
        } else {
          return true
        }
      },
      getRowKeys (row) {
        return row.sku_id
      },
      handleCurrentChange (page_num) {
        this.$refs.multipleTable.clearSelection()
        this.params.page = page_num
        this.getNewsList()
      },
      searchByKey () {
        if (this.select_tags_value) {
          this.params.tag_id = this.select_tags_value[0]
        }
        this.params.page = 1
        this.getNewsList()
      },
      handleSelectAll (val) {
        if (this.limitNum) {
          this.$message({message: '当前组件不支持全选', type: 'warning'})
          this.$refs.multipleTable.clearSelection()
          this.itemsData.forEach(item => {
            let checked = this.selectRows.find(n => n.sku_id === item.sku_id)
            if (checked) {
              this.$refs.multipleTable.toggleRowSelection(item)
            }
          })
          return
        }
        if (val.length > 0) {
          val.forEach(item => {
            let inChecked = this.selectRows.findIndex(n => item.sku_id === n.sku_id)
            if (inChecked === -1) {
              this.selectRows.push(item)
            }
          })
        } else {
          this.itemsData.forEach((item, index) => {
            let inChecked = this.selectRows.findIndex(n => item.sku_id === n.sku_id)
            if (inChecked !== -1) {
              this.selectRows.splice(inChecked, 1)
            }
          })
        }
      },
      handleSelectChange (val, row) {
        let inChecked = this.selectRows.findIndex(item => row.sku_id === item.sku_id)
        if (inChecked !== -1) {
          this.selectRows.splice(inChecked, 1)
        } else {
          if (this.limitNum && this.limitNum == 1) {
            this.selectRows = []
            this.selectRows.push(row)
            this.$refs.multipleTable.clearSelection()
            this.selectRows.forEach(item => {
              this.$refs.multipleTable.toggleRowSelection(item)
            })
            return
          } else if (this.limitNum && this.selectRows.length >= this.limitNum) {
            this.$message({message: `最多选择${this.limitNum}件商品`, type: 'warning'})
            this.$refs.multipleTable.clearSelection()
            this.selectRows.forEach(item => {
              this.$refs.multipleTable.toggleRowSelection(item)
            })
            return
          }
          this.selectRows.push(row)
        }
      },
      cancelAction () {
        this.selectRows = []
        this.$emit('closeStoreDialog')
      },
      saveStoreAction () {
        // console.log(this.selectRows)
        this.$emit('chooseStore', this.selectRows)
      },
      getNewsList () {
        if (this.getStatus) {
          this.loading = true
          getSkuList(this.params).then(response => {
            this.itemsData = response.data.data.list
            this.total_count = parseInt(response.data.data.total_count)
            this.loading = false
          })
        }
      },
      // getShippingTemplatesList () {
      //   this.loading = true
      //   getShippingTemplatesList(this.templatesParams).then(response => {
      //     this.templatesList = response.data.data.list
      //   })
      // },
      // getCurrencyInfo () {
      //   getDefaultCurrency().then(res => {
      //     this.currency = res.data.data
      //     this.cursymbol = this.currency.symbol
      //   })
      // },
      // getCategory () {
      //   getCategory([]).then(response => {
      //     this.categoryList = response.data.data
      //   })
      // },
      priceformatter (row, column) {
        return this.cursymbol + row.price
      },
      // changeGoods (type) {
      //   switch (type) {
      //     case 'every':
      //       this.$set(this.params, 'consume_type', 'every')
      //       this.$delete(this.params, 'item_type')
      //       this.itemType = 'every'
      //       break
      //     case 'normal':
      //       this.$set(this.params, 'item_type', 'normal')
      //       this.$delete(this.params, 'consume_type')
      //       this.itemType = 'normal'
      //       break
      //   }
      //   this.getNewsList()
      // }
    },
    mounted () {
      if (this.filter) {
        let filters = this.filter
        let params = this.params
        if (typeof (filters) === 'string') {
          filters = JSON.parse(filters)
        }
        Object.assign(params, filters)
        this.params = params
      }
      // this.getShippingTemplatesList()
      // this.getCurrencyInfo()
    },
    computed: {
      showDialog () {
        return this.itemsVisible
      },
      singleData () {
        return this.single
      }
    },
    watch: {
      itemsVisible (val) {
        if (val) {
          this.params.keywords = ''
          this.params.sku_bn = ''
          this.getNewsList()
          if (this.isSpec) {
            this.params.is_sku = this.isSpec
          }
          if (this.notSku) {
            Object.assign(this.params, {nospec: true})
          }
          let ids = []
          this.loading = true
          this.multipleSelection.forEach(item => {
            ids.push(item.sku_id)
          })
          if (ids.length > 0) {
            let param = JSON.parse(JSON.stringify(this.params))
            param.page = 1
            param.pageSize = 999
            param.sku_id = ids
            this.selectRows = []
            getSkuList(param).then(res => {
              this.selectRows = res.data.data.list
              this.$refs.multipleTable.clearSelection()
              this.itemsData.forEach(item => {
                let checked = this.selectRows.find(n => n.sku_id === item.sku_id)
                if (checked) {
                  this.$refs.multipleTable.toggleRowSelection(item)
                }
              })
              this.loading = false
            })
          } else {
            const that = this
            this.$nextTick(() => {
              that.$refs.multipleTable.clearSelection()
            })
            this.loading = false
          }
        }
      },
      relItemsIds (newVal, oldVal) {
        if (newVal.length > 0) {
          this.multipleSelection = newVal
        }
      },
      itemsData (val) {
        if (this.selectRows.length > 0) {
          this.itemsData.forEach(item => {
            let checked = this.selectRows.find(n => n.sku_id === item.sku_id)
            if (checked) {
              this.$refs.multipleTable.toggleRowSelection(item)
            }
          })
        }
      },
      getStatus (newVal, oldVal) {
        if (newVal) {
          this.getNewsList()
        }
      },
      itemType (newVal, oldVal) {
        if (newVal) {
          this.params.item_type = newVal
        }
      },
      hiddenData (val) {
        this.hiddenItem = val
      },
      single (val) {
        this.singleData = val
      }
    }
  }
</script>

<style scoped lang="scss">
  .store {
    margin-bottom: 10px;
  }
  .store-dialog .el-checkbox {
    display: inline;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .el-select .el-input {
    width: 130px;
  }
  .pager {
    margin-top: 20px;
  }
  .tab-group {
    .tab-btn {
     &.on {
       border-color: #e6a23c;
       background-color: #e6a23c;
       color: #fff;
     }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?50f8db59